import { Tooltip } from '@cotera/client/app/components/ui';
import { round } from 'lodash';
import { classNames } from '../../utils';
import { useState } from 'react';

export const SvgBar: React.FC<{
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  category: string | null;
  rows: number;
  percent: number;
  onClick?: (category: string | null) => void;
  isActive: boolean;
}> = ({
  x,
  y,
  width: barWidth,
  height,
  color,
  category,
  rows,
  percent,
  onClick,
  isActive,
}) => {
  const textCategory = category ?? 'null';
  const isNullCategory = textCategory === 'null';
  const [isHovered, setHovered] = useState(false);

  // Calculate if text should be shown (similar to your original logic)
  const shouldShowText = barWidth > textCategory.length * 6;

  const getNullFillColor = () => {
    if (isNullCategory) {
      if (isActive) {
        return 'url(#nullStripesActive)';
      }
      if (onClick && isHovered) {
        return 'url(#nullStripesHover)';
      }
      return 'url(#nullStripes)';
    }

    return undefined;
  };

  // Calculate text position
  const textX = x + barWidth / 2;
  const textY = height / 2;

  const handleClick = () => {
    if (onClick) {
      onClick(category);
    }
  };

  return (
    <Tooltip
      tooltipContent={`${rows} rows (${round(percent, 2)}%) ${category}`}
      side="bottom"
    >
      <g>
        <rect
          x={x}
          y={y}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          width={barWidth}
          height={height}
          fill={getNullFillColor()}
          stroke="rgba(255,255,255,0.1)"
          strokeWidth={0.5}
          className={classNames(
            onClick ? 'cursor-pointer' : 'cursor-default',
            color
          )}
          onClick={handleClick}
          style={{
            transition: 'fill 0.2s ease',
          }}
        />

        {shouldShowText && (
          <text
            x={textX}
            y={textY}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="10"
            className={classNames(
              onClick
                ? 'cursor-pointer pointer-events-none'
                : 'pointer-events-none'
            )}
          >
            {textCategory}
          </text>
        )}
      </g>
    </Tooltip>
  );
};
